// @flow
import { GB_TO_MB } from '../../../element/Styled';

import type { BbServerParams, UserDataEdit } from '../../../../api/type.srv';
import type { EditGigabytes } from '../../../hoc/Volumes';
import type { BbCollectedImage } from '../../../../api/type';
import type { BbAccount } from '../../../../api/type.acc';
import type { Megabytes } from '../../../../api/type.units';

// The API maxes at 65535 but Base64 means some unusable bytes
const MAX_USER_DATA_SIZE = 65532; // 64 KiB in bytes - 4 bytes

export function validateUserData(data: UserDataEdit): [?string, ?$Shape<BbServerParams>] {
    let finalEncodedValue: string;

    if (data.isBase64Encoded) {
        finalEncodedValue = data.value;
    } else {
        try {
            finalEncodedValue = btoa(data.value);
        } catch (e) {
            return ['Data contains characters that cannot be Base64 encoded', null];
        }
    }

    // Validate the encoded size
    if (finalEncodedValue.length > MAX_USER_DATA_SIZE) {
        return [
            'Data size limit exceeded',
            null
        ];
    }

    return [
        null,
        { user_data: finalEncodedValue }
    ];
}

export function validateVolume(root_volume: EditGigabytes, account: ?BbAccount, image: ?BbCollectedImage, existingSize: ?Megabytes): [?string, ?number] {
    const parsed = parseFloat(root_volume);
    const availableBlockStorage = account
        ? ((account.block_storage_limit - account.block_storage_used + (existingSize || 0)) / GB_TO_MB)
        : window.cgrConfig.VOLUME_LIMITS.max;
    const maxVolumeSize = Math.min(availableBlockStorage, window.cgrConfig.VOLUME_LIMITS.max);

    if (image && image.virtual_size > (parsed * GB_TO_MB)) {
        return [ `The selected image needs a volume of at least ${image.virtual_size / GB_TO_MB}GB`, null];
    }

    if (existingSize && existingSize > (parsed * GB_TO_MB)) {
        return [ `Volumes can only be increased in size; volume must be at least ${existingSize / GB_TO_MB}GB`, null];
    }

    if (existingSize && existingSize === (parsed * GB_TO_MB)) {
        return [ `The volume is already ${existingSize / GB_TO_MB}GB`, null];
    }

    if (isNaN(parsed) || parsed > maxVolumeSize || parsed < window.cgrConfig.VOLUME_LIMITS.min) {
        return [ `Please enter a valid size between ${existingSize ? (existingSize / GB_TO_MB) : window.cgrConfig.VOLUME_LIMITS.min}GB and ${maxVolumeSize}GB`, null ];
    }

    return [null, parsed];
}